/* eslint-disable import/prefer-default-export */
const backend = {
  positionName: 'Back-end Developer PHP/Symfony',
  offer: {
    title: 'Nasza oferta:',
    sectionList: [
      'Praca nad własnym produktem (możesz mieć wpływ na to co aktualnie produkujemy).',
      'Praca z wykorzystaniem nowoczesnych technologii (Symfony 5+, Docker, Kubernetes, AWS).',
      'Praca w startupowej atmosferze - dobra opcja dla ludzi ambitnych, lubiących wychodzić z własną inicjatywą, nie bojących się różnorodnych zadań.',
      'Praca w zgodzie z dobrymi praktykami: piszemy testy automatyczne, stosujemy Code Review i GitFlow (choć powoli migrujemy do Continuous Delivery).',
      'Wsparcie od reszty zespołu.',
      'Elastyczne godziny pracy.',
      'Możliwość nauki podstaw systemu Linux, Dockera, narzędzi służących do Continuous Delivery.',
      'Praca w Scrumie. Jeden dzień w sprincie programiści sami decydują co chcą robić.',
      'Karta Multisport, opieka medyczna, ubezpieczenie.',
      'Różne formy zatrudnienia.',
      'Dla chętnych: oryginalne biuro, w którym można grillować, pograć w ping-ponga, zaparkować rower czy się odświeżyć.',
    ],
  },
  requirementsMust: {
    title: 'Wymagania:',
    sectionList: [
      'Znajomość PHP 7+ i Symfony.',
      'Znajomość dobrych praktyk programistycznych.',
      'Przynajmniej podstawowa znajomość Gita.',
      'Przynajmniej podstawowa znajomość relacyjnych baz danych (preferowany PostgreSQL).',
      'Chęci i siły do ciągłego rozwoju.',
    ],
  },
  requirementsNiceToHave: {
    title: 'Dodatkowym plusem będzie:',
    sectionList: [
      'Przynajmniej podstawowa znajomość języków i narzędzi frontendowych: HTML, CSS, JS, React, Redux.',
      'Znajomość dowolnych platform e-commerce.',
    ],
  },
};

const frontend = {
  positionName: 'Javascript/React Developer',
  offer: {
    title: 'Nasza oferta:',
    sectionList: [
      'Praca nad własnym produktem (możesz mieć wpływ na to co aktualnie produkujemy).',
      'Praca z wykorzystaniem nowoczesnych technologii (m.in. React, Redux, TypeScript, Next.js, SSR, Webpack, Docker, Playwright, Jest).',
      'Praca w małym zespole, co oznacza duży wpływ na rozwój produktu.',
      'Praca w zgodzie z dobrymi praktykami: piszemy testy automatyczne, stosujemy Code Review. Od GitFlow odchodzimy na rzecz Continuous Delivery.',
      'Wsparcie od reszty zespołu, praca w wesołej atmosferze.',
      'Elastyczne godziny pracy.',
      'Praca zdalna.',
      'Karta Multisport, opieka medyczna, ubezpieczenie.',
      'Możliwość nauki podstaw systemu Linux, Dockera, narzędzi służących do Continuous Delivery.',
      'Różne formy zatrudnienia.',
    ],
  },
  requirementsMust: {
    title: 'Wymagania:',
    sectionList: [
      'Dobra znajomość Javascriptu, HTML-a i CSS.',
      'Przynajmniej rok doświadczenia w pracy Reactem i Reduksem (komercyjne lub open source).',
      'Przynajmniej podstawowa wiedza na temat automatyzacji testów.',
      'Podstawowa znajomość Redux Toolkit.',
      'Podstawowa znajomość Gita.',
      'Chęci i siły do ciągłego rozwoju.',
    ],
  },
};

export { backend, frontend };
